import React, { Component } from 'react'
import Error from './error'
class FourOhFour extends Component {
  render () {
    return (
      <Error code={404} />
    )
  }
}
export default FourOhFour



// WEBPACK FOOTER //
// ./src/views/core/404.js